import { UseMutateFunction, useMutation } from "@tanstack/react-query";
import {
  QuestionSearchResultDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_QUESTIONS } from "../domain";

import { questionsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_SEARCH_QUESTIONS = "SEARCH_QUESTIONS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const searchQuestions = async (
  searchTerm: string,
): Promise<QuestionSearchResultDto[]> => {
  const response = await questionsApi.questionsControllerSearchQuestion(searchTerm);

  return response.data;
};

export const useSearchQuestions = (
  user: UserProfileDto | null,
): {
  searchResults?: QuestionSearchResultDto[];
  searchQuestions: UseMutateFunction<
    QuestionSearchResultDto[],
    unknown,
    string,
    unknown
  >;
  searchQuestionsAsync: UseMutateFunction<
    QuestionSearchResultDto[],
    unknown,
    string,
    unknown
  >;
  searchQuestionsEnabled: boolean;
  isSuccessSearchQuestions: boolean;
  isPendingSearchQuestions: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { mutate, mutateAsync, isSuccess, isPending, data } = useMutation({
    mutationKey: [DOMAIN_QUESTIONS, ACTION_SEARCH_QUESTIONS],
    mutationFn: enabled ? searchQuestions : undefined,
  });

  return {
    searchResults: data,
    searchQuestions: mutate,
    searchQuestionsAsync: mutateAsync,
    searchQuestionsEnabled: enabled,
    isSuccessSearchQuestions: isSuccess,
    isPendingSearchQuestions: isPending,
  };
};
